
import React, { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";

const GetBillersProduct = () => {
    const [billersProducts, setBillersProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [currentMessagePage, setCurrentMessagePage] = useState(1);
    const [messagesPerPage] = useState(20); // Number of items per page
    // const { permissions } = useContext(AuthContext);

    //   console.log("this is permissions", permissions);

    const navigate = useNavigate();
    const location = useLocation();
    const billers = location.state?.billers;
    const billerName = billers.name;
    const billerId = billers.id;

    //axios api encryption call
    const axios = AxiosApiCall();

    useEffect(() => {
        const fetchBillerProducts = async () => {
            setLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                if (!token) {
                    throw new Error("No access token found.");
                }
                const actualToken = token.split("|")[1];

                const response = await axios.post(
                    ApiServices.getSwitchers,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${actualToken}`,
                            token: token,
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );
                //    console.log("bill product",response.data);
                const { status, message, data } = response.data;
                if (status === 200 && data && data.products) {
                    const filteredProducts = data.products.filter(product => product.biller_id === billerId);
                    setBillersProducts(filteredProducts);
                    toast.success(message, { toastId: "flash-sales-fetch-success" });
                } else {
                    handleError({ response: { status, data: { message } } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setLoading(false);
            }
        };

        fetchBillerProducts();
    }, [billerId]);



    // Function to format permission text
    const formatText = (text) => {
        let formattedText = text.replace(/_/g, " ");
        formattedText = formattedText
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
        return formattedText;
    };


    // Filter data by name
    const handleFilter = (e) => {
        setFilterText(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
    };

    const filteredItems = billersProducts.filter((item) =>
        Object.values(item).some(value =>
            typeof value === "string" &&
            value.toLowerCase().includes(filterText.toLowerCase())
        )
    );

    // Pagination Logic
    const indexOfLastMessage = currentMessagePage * messagesPerPage;
    const indexOfFirstMessage = indexOfLastMessage - messagesPerPage;
    const currentMessages = filteredItems.slice(indexOfFirstMessage, indexOfLastMessage);

    const totalPages = Math.ceil(filteredItems.length / messagesPerPage);

    const paginateMessages = (pageNumber) => {
        setCurrentMessagePage(pageNumber);
    };

    // Function to format permission text
    const formatPermissionText = (text) => {
        // Replace underscores with spaces
        let formattedText = text.replace(/_/g, " ")
        // Capitalize the first letter of each word
        formattedText = formattedText
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());

        return formattedText;
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">Billers Product</p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">List</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
                        <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
                            <input
                                type="search"
                                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Search"
                                value={filterText}
                                onChange={handleFilter}
                            />
                        </div>
                        <Link
                            to="/admin/billers/list"
                            className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        >
                            <span className="flex justify-center sm:justify-start mx-2">
                                Go Back
                            </span>
                        </Link>
                    </div>

                    <h6 className="text-orange1">{formatText(billerName).toUpperCase()}</h6>

                    {loading ? (
                        <Spinner loading={loading} />
                    ) : filteredItems.length > 0 ? (
                        <div className="flex flex-wrap -m-2">
                            {currentMessages.map((product) => (
                                <div className="p-2 w-1/4" key={product.id}>
                                    <div className="bg-darkGreen3 text-dGrey3 mt-2 rounded flex p-2 h-full items-center">
                                        <span className="title-font font-medium">
                                            {formatPermissionText(product.name)}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="p-4 text-center text-gray-500">
                            No biller products found.
                        </div>
                    )}

                    {/* Pagination Controls */}
                    <div className="flex justify-end items-center mt-4">
                        <nav aria-label="Page navigation">
                            <ul className="pagination flex mx-auto">
                                <li className={`page-item ${currentMessagePage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2"
                                        onClick={() => paginateMessages(currentMessagePage - 1)}
                                        disabled={currentMessagePage === 1}
                                    >
                                        Prev
                                    </button>
                                </li>
                                <li className={`page-item ${currentMessagePage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2"
                                        onClick={() => paginateMessages(currentMessagePage + 1)}
                                        disabled={currentMessagePage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                </div>
            </MainLayouts>
        </div>
    );
};

export default GetBillersProduct;


